<template>
  <div class="modal-content">
    <AppNotification
      v-if="showProxyCountWarning"
      confirm-text="Да, изменить"
      cancel-text="Отмена"
      @confirm="confirmProxyCountChange"
      @cancel="cancelProxyCountChange"
    >
      Изменить количество прокси для парсинга?
      <br />
      (изменения вступят в силу в следующем цикле)
    </AppNotification>
    <AppNotification
      v-if="showDeleteProxyWarning"
      confirm-text="Да, удалить"
      cancel-text="Отмена"
      @confirm="confirmDeleteProxy"
      @cancel="cancelDeleteProxy"
    >
      Удалить данный адрес прокси?
    </AppNotification>
    <div class="modal-controls">
      <div class="add-parser-container">
        <div class="form-group custom-form-group">
          <label class="form-control-label" for="parser-address">Адрес:</label>
          <input
            v-model="address"
            id="parser-address"
            type="text"
            class="form-control form-control-light parser-addres-input"
            placeholder="Адрес прокси"
          />
        </div>
        <button
          class="btn btn-success add-proxy-btn"
          type="button"
          @click.self="handleAddProxy"
          :disabled="!isValidProxy || isProxyAlreadyExist"
        >
          Добавить прокси
        </button>
      </div>
      <div class="form-group custom-form-group disable-proxy-label">
        <label class="form-control-label">Выключить прокси:</label>
      </div>
      <div class="form-group custom-form-group">
        <label class="form-control-label">Количество активных прокси:</label>
        <div>
          <AppSelect v-model="proxyCountModel" :options="options" />
        </div>
      </div>
    </div>
    <div class="proxyExistError" v-if="isProxyAlreadyExist">
      Данный адрес прокси уже присутствует в таблице
    </div>
    <div class="proxy-wrapper">
      <table>
        <thead>
          <tr>
            <th class="number">Номер</th>
            <th class="time">Время добавления</th>
            <th>IP-адрес:Порт</th>
            <th class="time proxy">
              <div class="proxy-header">
                <span>icetrade</span>
                <AppSwitch v-model="useProxyIcetrade" active-color="#00BA82" />
              </div>
            </th>
            <th class="time proxy">
              <div class="proxy-header">
                <span>goszakupki</span>
                <AppSwitch
                  v-model="useProxyGoszakupki"
                  active-color="#00BA82"
                />
              </div>
            </th>
            <th class="actions"></th>
          </tr>
        </thead>
        <tbody>
          <NewProxyItem
            v-for="(item, index) in proxies"
            :key="item.id"
            :proxy="item"
            :index="index"
            @delete-proxy="handleDeleteProxy"
            @refresh-proxy="handleRefreshProxy"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AppNotification from "../common/AppNotification.vue";
import AppSelect from "../common/AppSelect.vue";
import AppSwitch from "../common/AppSwitch.vue";
import NewProxyItem from "./NewProxyItem.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "NewProxyModal",
  components: { AppSwitch, NewProxyItem, AppSelect, AppNotification },
  data() {
    return {
      address: "",
      options: Array.from({ length: 20 }, (_, i) => ({
        id: i + 1,
        label: String(i + 1),
      })),
      tempProxyCount: null,
      showProxyCountWarning: false,
      proxyToDelete: null,
      showDeleteProxyWarning: false,
    };
  },
  methods: {
    ...mapActions("proxies", [
      "getProxies",
      "getProxySettings",
      "updateProxySetting",
      "addProxy",
      "deleteProxy",
      "refreshProxy",
    ]),

    handleAddProxy() {
      this.addProxy({ proxy: this.address });
      this.address = "";
    },
    handleDeleteProxy(proxy) {
      this.proxyToDelete = proxy;
      this.showDeleteProxyWarning = true;
    },

    confirmProxyCountChange() {
      this.updateProxySetting({
        setting: "COUNT_OF_ACTIVE_PROXY",
        value: this.tempProxyCount,
      });

      this.tempProxyCount = null;
      this.showProxyCountWarning = false;
    },

    cancelProxyCountChange() {
      this.tempProxyCount = null;
      this.showProxyCountWarning = false;
    },

    confirmDeleteProxy() {
      if (this.proxyToDelete) {
        this.deleteProxy(this.proxyToDelete.id);
      }
      this.proxyToDelete = null;
      this.showDeleteProxyWarning = false;
    },

    cancelDeleteProxy() {
      this.proxyToDelete = null;
      this.showDeleteProxyWarning = false;
    },

    handleRefreshProxy(proxy, source) {
      this.refreshProxy({
        id: proxy.id,
        source,
      });
    },
  },

  computed: {
    ...mapGetters("proxies", ["proxies", "settings"]),
    useProxyGoszakupki: {
      get() {
        const useProxyItem = this.settings.find(
          (item) => item.setting === "USE_PROXY",
        );
        return useProxyItem ? useProxyItem.value : false;
      },
      set(value) {
        this.updateProxySetting({
          setting: "USE_PROXY",
          value,
        });
      },
    },
    useProxyIcetrade: {
      get() {
        const useProxyItem = this.settings.find(
          (item) => item.setting === "USE_PROXY_ICETRADE",
        );
        return useProxyItem ? useProxyItem.value : false;
      },
      set(value) {
        this.updateProxySetting({
          setting: "USE_PROXY_ICETRADE",
          value,
        });
      },
    },
    countOfActiveProxy() {
      const item = this.settings.find(
        (item) => item.setting === "COUNT_OF_ACTIVE_PROXY",
      );
      return item ? item.value : null;
    },
    proxyCountModel: {
      get() {
        return this.countOfActiveProxy;
      },
      set(value) {
        this.tempProxyCount = value;
        this.showProxyCountWarning = true;
      },
    },
    isValidProxy() {
      const parts = this.address.split(":");
      if (parts.length !== 4) return false;

      const [host, port, login, password] = parts;

      const isIp = /^(\d{1,3}\.){3}\d{1,3}$/.test(host);
      const isDomain = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(host);

      return (
        (isIp || isDomain) &&
        /^\d{1,5}$/.test(port) &&
        login.length > 0 &&
        password.length > 0
      );
    },

    isProxyAlreadyExist() {
      return this.proxies.find((proxy) => proxy.proxy === this.address);
    },
  },

  created() {
    this.getProxies();
    this.getProxySettings();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variables.less";

.proxyExistError {
  display: flex;
  align-items: center;
  background-color: #ffe5e5;
  color: #fe2712;
  width: 100%;
  height: 44px;
  padding: 10px 15px;
  border-radius: 4px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.modal-content {
  position: relative;
  .modal-controls {
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    .add-parser-container {
      display: flex;
      width: max-content;
      gap: 8px;
      flex-direction: column;
      .custom-form-group {
        margin-bottom: 0;
        .parser-addres-input {
          width: 300px;
        }
      }
      .add-proxy-btn {
        height: 40px;
      }
    }
    .switch-container {
      height: 40px;
      display: flex;
      align-items: center;
    }
    .disable-proxy-label {
      position: absolute;
      top: 94px;
      left: 632px;
      z-index: 999;
    }
  }
  .proxy-wrapper {
    overflow: hidden;
    max-height: 546px;
    &::-webkit-scrollbar {
      border-radius: @br;
      width: 8px;
      height: 8px;
      background-color: #ffffff;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: @br;
      width: 8px;
      height: 8px;
      background-color: fade(#000000, 24%);
      &:hover {
        background-color: fade(#000000, 30%);
      }
    }
    table {
      border-collapse: collapse;
      border-spacing: 0;
      width: 100%;
      height: auto;
      text-align: left;

      tbody {
        display: block;
        max-height: 504px;
        overflow-y: auto;
        width: 100%;
      }

      tr {
        display: table;
        width: 100%;
        table-layout: fixed;
      }
      th {
        position: sticky;
        top: 0;
        z-index: 1;
        vertical-align: bottom;
        border: none;
        border-bottom: 2px solid @bg-color-light;
        padding: 12px 16px;
        font-weight: 500;
        color: @text-color-light;
        background-color: #ffffff;
        &.number {
          width: 80px;
        }
        &.actions {
          padding: 4px 0;
          width: 47px;
        }
        &.time {
          width: 170px;
        }
        &.proxy {
          width: 186px;
          .proxy-header {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
          }
        }
      }
    }
  }
}
</style>
